import { FormattedMessage } from "react-intl";

const CrossTeamPlanning = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.crossTeamPlanning.content.body"
                    defaultMessage="Plan and track goals, projects, and dependencies in one place."
                />
            </p>
        </div>
    );
};

export default CrossTeamPlanning;
